import React from 'react';

const BlockedUsers = ({ color }) => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.99984 0.666504C3.95184 0.666504 0.666504 3.95184 0.666504 7.99984C0.666504 12.0478 3.95184 15.3332 7.99984 15.3332C12.0478 15.3332 15.3332 12.0478 15.3332 7.99984C15.3332 3.95184 12.0478 0.666504 7.99984 0.666504ZM2.13317 7.99984C2.13317 4.7585 4.7585 2.13317 7.99984 2.13317C9.3565 2.13317 10.6032 2.59517 11.5932 3.3725L3.3725 11.5932C2.59517 10.6032 2.13317 9.3565 2.13317 7.99984ZM7.99984 13.8665C6.64317 13.8665 5.3965 13.4045 4.4065 12.6272L12.6272 4.4065C13.4045 5.3965 13.8665 6.64317 13.8665 7.99984C13.8665 11.2412 11.2412 13.8665 7.99984 13.8665Z" fill={color}/>
       </svg>
    )
}
export default BlockedUsers;